export default "__VITE_ASSET__DxW5qblX__"